module.exports = __webpack_public_path__ + "static/media/cruiser.722873e1.svg";